import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

var config = { // 본인의 설정으로 진행
  apiKey: "AIzaSyAUqZc_6mGWUiG34_cGWgk56nDF_1WL7dQ",
  authDomain: "osp18-5.firebaseapp.com",
  databaseURL: "https://osp18-5.firebaseio.com",
  projectId: "osp18-5",
  storageBucket: "osp18-5.appspot.com",
  messagingSenderId: "581938170150"
};

firebase.initializeApp(config);

const db = firebase.firestore();
db.settings({
    timestampsInSnapshots: true
});
const dbRef = db.collection('todos');
const dbCtgs = db.collection('category');

const authRef = firebase.auth();
authRef.setPersistence(firebase.auth.Auth.Persistence.SESSION);
const gProvider = new firebase.auth.GoogleAuthProvider();

export { authRef, dbRef, dbCtgs, gProvider };



// WEBPACK FOOTER //
// ./src/store/db.js